import React from 'react';
import {useRef, useMemo} from 'react';
import {VisualizationSpec} from 'react-vega';
import CustomPanelRenderer from '../Vega3/CustomPanelRenderer';
import {useGatedValue, useOnScreen} from '../../state/hooks';
import * as Panel2 from './panel';
import * as CGReact from './cg/cgreact';

const inputType = {
  type: 'array' as const,
  objectType: {
    type: 'union' as const,
    members: [null, 'number' as const],
  },
};

type PanelHistogramProps = Panel2.PanelProps<typeof inputType>;

/* eslint-disable no-template-curly-in-string */

const HISTO_SPEC: VisualizationSpec = {
  $schema: 'https://vega.github.io/schema/vega-lite/v4.json',
  description: 'A simple histogram',
  data: {
    name: 'wandb',
  },
  title: '${string:title}',
  mark: {type: 'bar', tooltip: {content: 'data'}},
  encoding: {
    x: {
      bin: {maxbins: 10},
      type: 'quantitative',
      field: '${field:value}',
      axis: {
        title: null,
      },
    },
    y: {
      aggregate: 'count',
      stack: null,
      axis: {
        title: null,
      },
    },
    opacity: {value: 0.7},
  },
};

const PanelHistogram: React.FC<PanelHistogramProps> = props => {
  const domRef = useRef<HTMLDivElement>(null);
  const onScreen = useOnScreen(domRef);
  const hasBeenOnScreen = useGatedValue(onScreen, o => o);
  const nodeValueQuery = CGReact.useNodeValue(props.input.path);
  const data = useMemo(() => {
    if (nodeValueQuery.loading) {
      return [];
    }
    return nodeValueQuery.result.map(num => ({value: num}));
  }, [nodeValueQuery]);
  return (
    <div ref={domRef} style={{width: 250, height: 160}}>
      {!nodeValueQuery.loading && hasBeenOnScreen ? (
        <CustomPanelRenderer
          spec={HISTO_SPEC}
          loading={props.loading}
          slow={false}
          data={data}
          userSettings={{
            fieldSettings: {value: 'value'},
            stringSettings: {title: ''},
          }}
        />
      ) : (
        <div
          style={{
            backgroundColor: '#eee',
            margin: 16,
            width: '100%',
            height: '100%',
          }}
        />
      )}
    </div>
  );
};

export const Spec: Panel2.PanelSpec = {
  id: 'histogram',
  Component: PanelHistogram,
  inputType,
};
